import React, { useState, useEffect, useContext } from 'react'
import { toast } from 'react-toastify'
import { Store } from '../../Utils/Store'

const DataManagement = () => {
  const { state, dispatch } = useContext(Store)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    contact_phone: [''],
    contact_email: '',
    address: '',
    facebook: '',
    twitter: '',
    linkedin: '',
    instagram: '',
    youtube: ''
  })

  useEffect(() => {
    // Load contact info from Store
    if (state.ContactInfo) {
      const phones = Array.isArray(state.ContactInfo.contact_phone) 
        ? state.ContactInfo.contact_phone 
        : state.ContactInfo.contact_phone 
          ? [state.ContactInfo.contact_phone] 
          : [''];
      
      setFormData({
        contact_phone: phones.length > 0 ? phones : [''],
        contact_email: state.ContactInfo.contact_email || '',
        address: state.ContactInfo.address || '',
        facebook: state.ContactInfo.facebook || '',
        twitter: state.ContactInfo.twitter || '',
        linkedin: state.ContactInfo.linkedin || '',
        instagram: state.ContactInfo.instagram || '',
        youtube: state.ContactInfo.youtube || ''
      })
    }
  }, [state.ContactInfo])

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handlePhoneChange = (index, value) => {
    const newPhones = [...formData.contact_phone]
    newPhones[index] = value
    setFormData({
      ...formData,
      contact_phone: newPhones
    })
  }

  const addPhoneNumber = () => {
    setFormData({
      ...formData,
      contact_phone: [...formData.contact_phone, '']
    })
  }

  const removePhoneNumber = (index) => {
    if (formData.contact_phone.length > 1) {
      const newPhones = formData.contact_phone.filter((_, i) => i !== index)
      setFormData({
        ...formData,
        contact_phone: newPhones
      })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    // Validate that at least one phone number is provided
    const validPhones = formData.contact_phone.filter(phone => phone && String(phone).trim() !== '')
    if (validPhones.length === 0) {
      toast.error('Please provide at least one phone number')
      return
    }
    
    if (!formData.contact_email || !formData.address) {
      toast.error('Email and address are required')
      return
    }
    
    setLoading(true)
    try {
      // Prepare data - ensure phone numbers are strings
      const submitData = {
        ...formData,
        contact_phone: validPhones.map(p => String(p).trim())
      }
      
      console.log('Saving contact info:', submitData)
      
      // Update Store
      dispatch({ type: 'UpdateContactInfo', payload: submitData })
      
      toast.success('Contact information updated successfully!')
    } catch (error) {
      console.error('Error updating contact info:', error)
      toast.error(error.message || 'Failed to update contact information')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div style={{ 
        backgroundColor: '#fff', 
        padding: '20px', 
        borderRadius: '8px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginBottom: '30px', color: '#333' }}>Data Management</h2>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
              Contact Phone Numbers: <span style={{ color: 'red' }}>*</span>
            </label>
            {formData.contact_phone.map((phone, index) => (
              <div key={index} style={{ display: 'flex', marginBottom: '10px', gap: '10px', alignItems: 'center' }}>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => handlePhoneChange(index, e.target.value)}
                  placeholder={`Phone ${index + 1} (e.g., +971507907682)`}
                  required={index === 0}
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '14px'
                  }}
                />
                {formData.contact_phone.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removePhoneNumber(index)}
                    style={{
                      padding: '10px 15px',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              onClick={addPhoneNumber}
              style={{
                padding: '8px 15px',
                backgroundColor: '#28a745',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
                marginTop: '5px'
              }}
            >
              + Add Another Phone Number
            </button>
          </div>
          
          <div className="row">
            <div className="col-md-6" style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Contact Email: <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="email"
                name="contact_email"
                value={formData.contact_email}
                onChange={handleInputChange}
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '14px'
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Address: <span style={{ color: 'red' }}>*</span>
            </label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
              rows={3}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '14px',
                fontFamily: 'inherit'
              }}
            />
          </div>

          <h3 style={{ marginTop: '30px', marginBottom: '20px', color: '#333' }}>Social Media Links</h3>

          <div className="row">
            <div className="col-md-6" style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Facebook URL:
              </label>
              <input
                type="url"
                name="facebook"
                value={formData.facebook}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '14px'
                }}
              />
            </div>

            <div className="col-md-6" style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Twitter URL:
              </label>
              <input
                type="url"
                name="twitter"
                value={formData.twitter}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '14px'
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6" style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                LinkedIn URL:
              </label>
              <input
                type="url"
                name="linkedin"
                value={formData.linkedin}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '14px'
                }}
              />
            </div>

            <div className="col-md-6" style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Instagram URL:
              </label>
              <input
                type="url"
                name="instagram"
                value={formData.instagram}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '14px'
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              YouTube URL:
            </label>
            <input
              type="url"
              name="youtube"
              value={formData.youtube}
              onChange={handleInputChange}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '14px'
              }}
            />
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '12px 30px',
                backgroundColor: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default DataManagement
